module.exports = __webpack_public_path__ + "static/img/91.7b6df59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/91.png
// module id = gbRh
// module chunks = 0